// ##### 25-02-05 Komarov
import { InputNumber, Select, Space } from 'antd';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';
import { markRequired } from '../../../../../../../helpers/markRequired';
import LodgingTypes from '../../../../../StaticJsonData/LodgingTypes.json';

// ##### Komarov 2025-07-14
const AccommodationComponent = ({ props }) => {
  const {
    selectingAccomTypes,
    accomType,
    accomTypeInitialState,
    SelectSingleRoomsAmount,
    SelectTwinRoomsAmount,
    selectStarRating,
    starRating,
    starRatingInitialState,
  } = props;
  // ##### Komarov 2025-08-05
  const language = useSelector(state => state.language);
  const groupRequestEstablishment = useSelector(state => state.pagesRedux[language]?.Group_request_establishment || '');
  const StarRating = useSelector(state => state.pagesRedux[language]?.StarRating || '');
  const SupplierForm_PleaseSelect = useSelector(state => state.pagesRedux[language]?.SupplierForm_PleaseSelect || '');

  return (
    <div className="groupTravelblocks_2_accommodation" key={uniqueId()}>
      <span>
        {
          // ##### 23-10-04 Komarov
          markRequired(groupRequestEstablishment)
        }
      </span>
      <Select
        onChange={selectingAccomTypes}
        bordered={true}
        style={{ minWidth: '5vw' }}
        // ##### 24-03-21 Komarov
        value={
          (accomType === accomTypeInitialState && SupplierForm_PleaseSelect) ||
          accomType
        }
      >
        <>
          {
            // ##### 24-03-21 Komarov
            LodgingTypes?.map(item => {
              if (item.lang === language) {
                return item.type.map(item1 => {
                  return (
                    <Option value={item1} key={item1}>
                      {item1}
                    </Option>
                  );
                });
              }
            })
          }
        </>
      </Select>

      <Select
        onChange={selectStarRating}
        bordered={true}
        style={{ marginLeft: '0.5vw', marginRight: '0,5vw' }}
        value={
          (starRating === starRatingInitialState && StarRating) || starRating
        }
      >
        {
          // ##### 24-03-21 Komarov
          StarRating?.map(item => {
            return (
              <Option value={item} key={item}>
                {item}
              </Option>
            );
          })
        }
      </Select>
      <span>
        {/* ##### 23-10-02 Komarov: TODO: заменить на перевод из Смарта */}
        Twin rooms
      </span>
      <Space>
        <InputNumber
          min={1}
          max={100000}
          defaultValue={1}
          onChange={SelectTwinRoomsAmount}
        />
      </Space>
      <span>
        {/* ##### 23-10-02 Komarov: TODO: заменить на перевод из Смарта */}
        Single rooms
      </span>
      <Space>
        <InputNumber
          min={1}
          max={100000}
          defaultValue={1}
          onChange={SelectSingleRoomsAmount}
        />
      </Space>
    </div>
  );
};

// ##### 25-05-21 Komarov
export default AccommodationComponent;
